export const WISHLIST = "local" as "local" | "centra";

export const VARIANTS_PER_DISPLAY = "multi";

export const ANIMATION_DURATION_CONTENT = 0.8;

export const YARN_TO_RECIPE_RATIO = 4;

export const SITE_NAME = "Raumagarn";
